/* eslint no-undef: 0 */
require("@babel/polyfill");

// Custom Scripts
import('./main-menu'   /*webpackChunkName: "main-menu"*/);

if( $('body').hasClass('blog') ) {
    import('./blog'   /*webpackChunkName: "blog"*/ );
}
if( $('body').hasClass('archive') ) {
    import('./archive'   /*webpackChunkName: "archive"*/ );
}
if( $('.contact-form').length > 0 ) {
    import('./gravityform'   /*webpackChunkName: "gravityform"*/ );
}
import './custom';
